import { render } from "./AddNewEmployee.vue?vue&type=template&id=05144bc2&scoped=true"
import script from "./AddNewEmployee.vue?vue&type=script&lang=js"
export * from "./AddNewEmployee.vue?vue&type=script&lang=js"

import "./AddNewEmployee.vue?vue&type=style&index=0&id=05144bc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05144bc2"]])

export default __exports__